import { Dispatch } from 'react';
import { PayloadAction } from 'typesafe-actions';
import { createContext } from 'use-context-selector';
import { CardContextActionTypes, CardsState } from './types';
import { defaultCardsProviderState } from './defaultState';

const CardsContext = createContext<CardsState>(defaultCardsProviderState({}));
const CardsDispatchContext = createContext<Dispatch<PayloadAction<CardContextActionTypes, any>> | undefined>(undefined);

export { CardsContext, CardsDispatchContext };
